module.exports = __webpack_public_path__ + "img/logo.f656d52d.svg";